import { render } from "./cardDocumentsComponent.vue?vue&type=template&id=234a92b5"
import script from "./cardDocumentsComponent.vue?vue&type=script&lang=js"
export * from "./cardDocumentsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__